export default "__VITE_ASSET__5484aa90__"